import '../components/loader.css'
export default function Loader() {
    return <>
        <div class="loader loader-bottom">
            <div class="dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>
    </> 
}